import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, concatMap, map, tap } from "rxjs/operators";

import * as PrivacyActions from "../actions/privacy.actions";
import { PrivacyService } from "../../services/privacy.service";
import {
  AcceptTerms,
  PrivacyState,
} from "../../interfaces/privacy-state.interface";
import { AnalyticsService } from "@serasa/shared/services/analytics.service";
import { SiteSection } from "@serasa/shared/enums/site-section.enum";

@Injectable()
export class PrivacyEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly _privacyService: PrivacyService,
    private readonly _analyticsService: AnalyticsService,
  ) { }

  loadTerms$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PrivacyActions.loadTerms),
      concatMap((action) =>
        this._privacyService.loadTerms<PrivacyState>().pipe(
          map((termsResponse: PrivacyState) =>
            PrivacyActions.loadTermsSuccess({ terms: termsResponse["terms"] }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(PrivacyActions.loadTermsFailure({ error })),
          ),
        ),
      ),
    );
  });

  sendAgreement$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PrivacyActions.loadAcceptTerms),
      concatMap((action) =>
        this._privacyService.sendAgreement<AcceptTerms>(action.version).pipe(
          concatMap((acceptResponse) =>
            of(
              PrivacyActions.acceptTermsSuccess({
                response: { success: true },
              }),
            ).pipe(
              tap(() => {
                this._analyticsService.doPageLoad("AceiteTermosDeUso:Sucesso", {
                  events: ["portalLogons_AceiteTermosSucesso"],
                });
              }),
            ),
          ),
          catchError((error: HttpErrorResponse) =>
            of(PrivacyActions.acceptTermsFailure({ error })).pipe(
              tap((error) => {
                this._analyticsService.sendCustomError(
                  error.error,
                  SiteSection.ERRO_AO_ACEITAR_TERMO,
                );
              }),
            ),
          ),
        ),
      ),
    );
  });
}
